import React, { ReactElement, useEffect, useState, useCallback, useRef } from "react"
import { get, post } from "../../../netApi/fetch"

import { connect } from "react-redux"

import { setLoginBindInfo } from "../../../reducers"

import BanUnLogin from "../../../high-component/BanUnLogin"
import Main from "../../../high-component/Content"
import { useHistory } from "react-router"
import styled from "styled-components"
import { imageType } from "../../../methods/imageUpload"
import { message, Select } from "antd"

// 定义类型
interface NoteType {
  id: string
  title: string
  content: string
  type: string
  image: string
  can_share: string
  show_read: string
  status: string
  createtime: string
  uid: string
  updatetime: string
  views: string
  comments: string
  reads: string
  sid: string
  images: imageType[]
}

interface NoteComponentProps {
  note?: NoteType
  history: ReturnType<typeof useHistory>
  setLoginBindInfo?: (data: any) => void
  user?: any
  loginBindInfo?: any
}

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
`

const CreationDate = styled.p`
  color: grey;
  font-size: 14px;
  margin-bottom: 15px;
`

const ImagesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 20px;
`

const ImageUploadButton = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ddd;
  border-radius: 8px;
  height: 120px;
  width: 120px;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: var(--theme-main);
  }

  input {
    display: none;
  }
`

const ImageItem = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    display: block;
  }

  .delete-image,
  .edit-image {
    position: absolute;
    top: 5px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
  }

  .delete-image {
    right: 5px;
  }

  .edit-image {
    right: 35px;
  }
`

const Content = styled.div`
  line-height: 1.6;
  margin-bottom: 20px;
  /* padding: 15px; */
  border-radius: 8px;
  /* border: 1px solid rgb(240, 240, 240); */
  min-height: 300px;
  font-size: 16px;
  line-height: 1.6;
  p {
    // 自然换行
    word-break: break-word;
    white-space: pre-wrap;
  }
`

const EditNoteButton = styled.button`
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #2980b9;
  }
`

const RightPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main, #3498db);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

// 全局加载蒙版
const GlobalLoadingOverlay = styled.div`
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
  border-radius: 12px;
`

const LoadingContent = styled.div`
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
`

const LoadingText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
`

const LoadingSubText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
`

const EditButton = styled.button`
  background-color: #fff;
  color: var(--theme-main);
  border: none;
  padding: 10px 20px;
  border-radius: 50vmin;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  &.disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
`

const EditButtonLignt = styled.button`
  background-color: var(--theme-main);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 50vmin;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  &.disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
`

const _defaultState: NoteType = {
  id: "10000",
  title: "",
  content: "",
  type: "1",
  image: "",
  can_share: "0", // 20250908 这俩保留字段暂时无用
  show_read: "0", // 20250908 这俩保留字段暂时无用
  status: "1",
  createtime: "2025-09-05 13:51:29",
  uid: "1000849186",
  updatetime: "2025-09-05 13:51:29",
  views: "0",
  comments: "0",
  reads: "0",
  sid: "1000849185",
  images: [],
}

const Note = (props): ReactElement => {
  console.log("Note props :>> ", props)
  const [isLogin, setIsLogin] = useState(props.user?.uid)
  // console.log("props :>> ", props)
  const [noteData, setNoteData] = useState<NoteType>(_defaultState)
  const [images, setImages] = useState<imageType[]>(noteData.images)
  const [loading, setLoading] = useState(false)
  const [generatedVideo, setGeneratedVideo] = useState<string | null>(null)
  const urlSearchParams = new URLSearchParams(props.location.search)
  const autoFocus = urlSearchParams.get("auto_focus") || ""
  const pageId = props.match.params.id
  const [hasGeneratedVideo, setHasGeneratedVideo] = useState(false)
  useEffect(() => {
    if (hasGeneratedVideo) return
    setHasGeneratedVideo(true)
    switch (autoFocus) {
      case "generatedVideo":
        handleGeneratedVideo()
        break
    }
  }, [pageId])
  const [generating, setGenerating] = useState(false)
  const [playbackRate, setPlaybackRate] = useState(1.5)
  const videoRef = React.useRef<HTMLVideoElement>(null)
  const pollingTimerRef = useRef<NodeJS.Timeout | null>(null)

  const isMounted = useRef(true)

  useEffect(() => {
    // 滚动到页面顶部
    window.scrollTo({ top: 0, behavior: "smooth" })
    return () => {
      isMounted.current = false
    }
  }, [])
  // history.replace(`/content/${noteData.id}?auto_focus=generatedVideo&contentid=${noteData.id}&videoid=${selectedVideoId}&soundid=${soundId}&soundurl=${encodeURIComponent(soundUrl)}`)
  const handleGeneratedVideo = () => {
    const contentid = urlSearchParams.get("contentid")
    const videoId = urlSearchParams.get("videoid")
    const soundId = urlSearchParams.get("soundid")
    const soundUrl = urlSearchParams.get("soundurl")
    if (!contentid || !videoId || !soundId || !soundUrl) {
      console.log("缺少生成视频的必要参数")
      return
    }
    setGenerating(true)
    // 立即清理地址栏参数，防止刷新重复生成
    history.replace(`/content/${contentid}`)
    // 生成视频接口增加 id 字段
    post("/ip/createvideo", { contentid, soundUrl, videoId, soundId })
      .then((res) => {
        if (!isMounted.current) return
        setGenerating(false)
        message.success("AI视频生成成功！")
        setGeneratedVideo(res.data.video_url)
        if (res.data.contentid !== noteData.id) {
          // 如果返回的 contentid 和当前的不一样，说明生成的是别的笔记，跳转过去
          props.history.replace(`/content/${res.data.contentid}`)
        }
      })
      .catch((err) => {
        if (!isMounted.current) return
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }
  console.log("pageId :>> ", pageId)
  const history = props.history

  // 轮询函数
  const startPolling = useCallback(() => {
    // 清除之前的定时器
    if (pollingTimerRef.current) {
      clearInterval(pollingTimerRef.current)
    }

    const timer = setInterval(() => {
      get("/content/view", { id: pageId })
        .then((res) => {
          console.log("轮询 /content/view res :>> ", res)
          setNoteData(res)
          setImages(res.images || [])
          if (res.mp4) {
            setGeneratedVideo(res.mp4.url)
          }

          // 如果状态不为"2"，停止轮询
          if (res.status !== 2) {
            setGenerating(false)
            if (pollingTimerRef.current) {
              clearInterval(pollingTimerRef.current)
              pollingTimerRef.current = null
            }
          }
        })
        .catch((err) => {
          console.error("轮询获取数据失败:", err)
          // 出错时也停止轮询
          setGenerating(false)
          if (pollingTimerRef.current) {
            clearInterval(pollingTimerRef.current)
            pollingTimerRef.current = null
          }
        })
    }, 5000)

    pollingTimerRef.current = timer
  }, [pageId])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    setLoading(true)
    get("/content/view", { id: pageId })
      .then((res) => {
        console.log("/content/view res :>> ", res)
        setNoteData(res)
        setImages(res.images || [])
        if (res.mp4) {
          setGeneratedVideo(res.mp4.url)
        }

        // 如果状态为"2"，开启轮询
        if (res.status === 2) {
          setGenerating(true)
          startPolling()
        }
      })
      .catch((err) => {
        console.error("获取数据失败:", err)
        if (!err) err = "获取数据失败"
        message.error(err.data || err.message || err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [pageId, startPolling])

  useEffect(() => {
    setIsLogin(props.user?.uid)
  }, [props.user])

  // 清理轮询定时器
  useEffect(() => {
    return () => {
      if (pollingTimerRef.current) {
        clearInterval(pollingTimerRef.current)
      }
    }
  }, [])

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner />
        </LoadingOverlay>
      )}
      <div
        style={{
          maxWidth: "1120px",
          position: "relative",
          width: "100%",
          minWidth: "300px",
          margin: "0 auto",
          paddingTop: "90px",
          minHeight: "100vh",
          padding: "0 20px 40px",
          marginTop: "10px",
        }}
      >
        {/* 主要内容区域 - 使用flex布局 */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "flex-start",
            flexDirection: window.innerWidth > 768 ? "row" : "column",
          }}
        >
          {/* 左侧主内容区域 */}
          <div style={{ flex: 1, minWidth: 0 }}>
            {/* 顶部导航栏 */}
            <div
              style={{
                position: "sticky",
                top: 0,
                left: 0,
                right: 0,
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 16px",
                zIndex: 10,
              }}
            >
              {/* 返回按钮 */}
              <div
                style={{
                  background: "#fff",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                  padding: "10px 20px",
                  borderRadius: "50vmin",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  localStorage.setItem("restore_content_edit_cache", "1")
                  return history.goBack()
                  // history.push(`/index/release/createContent?restore_cache=1`)
                }}
              >
                返回上一页
              </div>

              {/* 中间标题 */}
              <div
                style={{
                  background: "#fff",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                  padding: "10px 20px",
                  borderRadius: "50vmin",
                  fontWeight: "bold",
                }}
              >
                笔记详情
              </div>

              {/* 右侧按钮 */}
              <div style={{ display: "flex", gap: "10px" }}>
                <EditButton onClick={() => props.history.push(`/contentedit/${noteData.id}`)} disabled={generating} className={generating ? "disabled" : ""}>
                  编辑
                </EditButton>
                <EditButtonLignt style={{}} onClick={() => props.history.push(`/contentedit/${noteData.id}?auto_focus=generatedVideo`)} disabled={generating} className={generating ? "disabled" : ""}>
                  生成视频
                </EditButtonLignt>
              </div>
            </div>

            <div
              style={{
                padding: "20px 30px",
                marginTop: "20px",
                backgroundColor: "#fff",
                borderRadius: "20px",
              }}
            >
              {noteData.title ? (
                <Title onDoubleClick={() => !generating && isLogin && props.history.push(`/contentedit/${noteData.id}?auto_focus=title`)}>{noteData.title}</Title>
              ) : (
                <Title style={{ color: "#999" }} onDoubleClick={() => !generating && isLogin && props.history.push(`/contentedit/${noteData.id}?auto_focus=title`)}>
                  无标题
                </Title>
              )}
              <CreationDate>创建于：{noteData.createtime}</CreationDate>

              {/* <ImagesContainer className="images">
                {images.map((image, index) => (
                  <ImageItem key={index} className="image">
                    <img src={image.url} alt="" />
                    <span className="delete-image" onClick={() => isLogin && props.history.push(`/contentedit/${noteData.id}?auto_focus=image_delete&id=${image.id}`)}>
                      ×
                    </span>
                  </ImageItem>
                ))}
                <ImageUploadButton onClick={(e) => isLogin && props.history.push(`/contentedit/${noteData.id}?auto_focus=image_add`)}>
                  <i className="iconfont icon-plus" style={{ fontSize: "24px", marginBottom: "5px" }}></i>
                  <span>添加图片</span>
                </ImageUploadButton>
              </ImagesContainer> */}

              <Content onDoubleClick={() => !generating && isLogin && props.history.push(`/contentedit/${noteData.id}?auto_focus=content`)}>
                <p>{noteData.content}</p>
              </Content>

              {/* {isLogin && <EditNoteButton onClick={() => props.history.push(`/contentedit/${noteData.id}`)}>编辑</EditNoteButton>} */}
            </div>
          </div>

          {/* 右侧面板 */}
          <div
            style={{
              width: window.innerWidth > 768 ? "320px" : "100%",
              flexShrink: 0,
            }}
          >
            <RightPanel
              style={{
                marginTop: "70px",
                height: "fit-content",
                position: "sticky",
                top: "70px",
              }}
            >
              <h3>生成视频</h3>
              {/* 全局加载蒙版 */}
              {generating ? (
                <GlobalLoadingOverlay>
                  <LoadingContent>
                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                      <LoadingSpinner />
                    </div>
                    <LoadingText>AI视频生成中...</LoadingText>
                    <LoadingSubText>
                      正在为您生成高质量的AI视频内容
                      <br />
                      预计需要3-5分钟，请耐心等待
                    </LoadingSubText>
                  </LoadingContent>
                </GlobalLoadingOverlay>
              ) : generatedVideo ? (
                <div>
                  <video
                    controls
                    ref={videoRef}
                    onLoadedMetadata={() => {
                      if (videoRef.current) {
                        videoRef.current.playbackRate = playbackRate
                      }
                    }}
                    style={{
                      width: "100%",
                      height: "320px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      background: "#000",
                    }}
                  >
                    <source src={generatedVideo} />
                    您的浏览器不支持视频播放
                  </video>
                  {/* 播放速度选择器 */}
                  <div style={{ display: "flex", alignItems: "center", marginTop: "8px", marginBottom: "4px" }}>
                    <span style={{ marginRight: "8px", fontSize: "14px", color: "#666" }}>播放速度：</span>
                    <Select
                      value={playbackRate}
                      onChange={(value) => {
                        setPlaybackRate(value)
                        if (videoRef.current) {
                          videoRef.current.playbackRate = value
                        }
                      }}
                      style={{ width: 120 }}
                      size="small"
                    >
                      <Select.Option value={0.5}>0.5x</Select.Option>
                      <Select.Option value={0.75}>0.75x</Select.Option>
                      <Select.Option value={1}>1x</Select.Option>
                      <Select.Option value={1.25}>1.25x</Select.Option>
                      <Select.Option value={1.5}>1.5x</Select.Option>
                      <Select.Option value={1.75}>1.75x</Select.Option>
                      <Select.Option value={2}>2x</Select.Option>
                    </Select>
                  </div>
                  <button
                    onClick={() => {
                      const link = document.createElement("a")
                      link.href = generatedVideo
                      link.download = `video_${noteData.id}.mp4`
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                    }}
                    style={{
                      width: "100%",
                      marginTop: "12px",
                      padding: "10px 20px",
                      backgroundColor: "#fff",
                      color: "var(--theme-main)",
                      border: "1px solid var(--theme-main)",
                      borderRadius: "50vmin",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      const target = e.target as HTMLButtonElement
                      target.style.backgroundColor = "var(--theme-main)"
                      target.style.color = "#fff"
                    }}
                    onMouseLeave={(e) => {
                      const target = e.target as HTMLButtonElement
                      target.style.backgroundColor = "#fff"
                      target.style.color = "var(--theme-main)"
                    }}
                  >
                    下载视频
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    minHeight: "260px",
                    color: "#666",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      background: "#f2f6fa",
                      borderRadius: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 16,
                    }}
                  >
                    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                      <defs>
                        <image id="image_0" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                        <pattern id="pattern_0" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
                          <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_0" />
                        </pattern>
                      </defs>
                      <rect id="ico-navigation-voiceover 1" width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_0)" />
                    </svg>
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8 }}>确认要表达的文字后</div>
                  <div style={{ fontSize: 14, color: "#999" }}>即可生成AI视频</div>
                </div>
              )}
            </RightPanel>
          </div>
        </div>
      </div>
    </>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLoginBindInfo: (data) => {
      dispatch(setLoginBindInfo(data))
    },
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    finishCheckLogin: state.finishCheckLogin,
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

export default BanUnLogin(Main(connect(mapStateToProps, mapDispatchToProps)(Note)))
